class MicroEvent {
	_bind(event, fct) {
		this._events = this._events || {};
		this._events[event] = this._events[event]	|| [];
		this._events[event].push(fct);
	}

	_unbind(event, fct) {
		this._events = this._events || {};
		if (event in this._events === false) return;
		this._events[event].splice(this._events[event].indexOf(fct), 1);
	}

	_trigger(event) {
		this._events = this._events || {};
		if (event in this._events === false) return;

		let l = this._events[event].length, i = -1;
		while (++i < l) {
			this._events[event][i].apply(this, Array.prototype.slice.call(arguments, 1));
		}
	}
}


export default MicroEvent;



// WEBPACK FOOTER //
// ./src/assets/js/microevent.js